module.exports = __webpack_public_path__ + "img/quest_icon_0067_helmet.f245ee14.png";